export const viewFields = {
  bid: {
    title: 'Информация о перевозке:',
    fields: [
      { label: 'Дата создания', field: 'created_at' },
      { label: 'Дата погрузки', field: 'order_date' },
      { label: 'Место погрузки', field: 'origin' },
      { label: 'Место выгрузки', field: 'destination' },
      { label: 'Культура', field: 'culture_name' },
      { label: 'Расстояние', field: 'distance' },
      { label: 'Количество машин', field: 'flights_count' },
      { label: 'Объем перевозки', field: 'tonnage' },
      { label: 'Стоимость за тонну', field: 'price_per_ton' },
      { label: 'Общая стоимость', field: 'total_price' },
    ],
  },
  customer: {
    title: 'Контакты заказчика:',
    fields: [
      { label: 'Название организации', field: 'org_name' },
      { label: 'ФИО', field: 'org_contact_person' },
      { label: 'Номер телефона', field: 'org_phone' },
    ],
  },
}

export const tableFields = [
  { label: 'Дата создания', field: 'created_at', width: 3 },
  { label: 'Дата погрузки', field: 'order_date', width: 3 },
  { label: 'Место погрузки', field: 'origin', width: 5 },
  { label: 'Место выгрузки', field: 'destination', width: 5 },
  { label: 'Расстояние', field: 'distance', width: 3 },
  { label: 'Стоимость', field: 'total_price', width: 3 },
]
